import React, { Component } from "react";
import { connect } from "react-redux";
import * as Actions from "./../../actions/index";

import routers from "./../../routers";
import "./style.css";
import * as LINK from "./../../constants/Links";
import { Spin, message } from 'antd';
class Login extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      login: '',
      user: {
        user: "",
        pass: ""
      },
      loading: false
    };
  }

  componentDidMount()
  {

  }
  static getDerivedStateFromProps(nextProps, prevState)
  {


    if (nextProps.login.user && nextProps.login !== prevState.login) {
      console.log(nextProps.login);
      return { login: nextProps.login };

    }
    else {
      return null;
    }
  }
  componentDidUpdate(prevProps, prevState)
  {

    if (this.state.login !== prevState.login) {
      let { login } = this.state

      if (login.user.code === 200) {
        let { setlogin } = this.props;
        if (setlogin) {
          setlogin();
        }

        window.location = LINK.HOME;
      }
      else {
        alert(login.user.message)
        let { ResetLogin } = this.props;
        ResetLogin();
      }
      this.SetLoading();
    }
  }
  SetLoading = () =>
  {
    this.setState(state =>
    {
      return {
        loading: !state.loading
      }
    })
  }


  OnchangeLogin = (event) =>
  {
    let target = event.target;
    let name = target.name;
    let value = target.value;
    this.setState(state =>
    {
      return {
        user: { ...state.user, [name]: value }
      }
    })
  }

  Login = () =>
  {
    let { user } = this.state;
    let { Login } = this.props;
    if (!user.user || !user.pass) {
      alert("Please enter full information!");
      return;
    }

    if (user.user === 'admin@binanstep.com' && user.pass === 'Lkakjj@@..s1@13w') {
      this.SetLoading();
      Login({ data: user, code: 200 })
    }
    else {
      message.warning('The user name or password you entered is incorrected.');

    }


  }
  OnkeyUpLogin = (event) =>
  {

    if (event.keyCode === 13) {
      this.Login();
    }
  }
  render()
  {

    return (
      <div className="login-select-chat">
        <div className="login_overlay"></div>
        <div className="login-form-chat">
          <div className="content-login-chat">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-12">
                  <div className="wrap">
                    {/* <div className="img" style={{ backgroundImage: `url(${LINK.endpoint}/images/ic_login.png)` }}></div> */}
                    <div className="login-wrap">
                      <form action="#" className="signin-form">
                        <div className="form-group mt-4">
                          <label className="form-control-placeholder" htmlFor="username">User Name</label>
                          <input type="text" name="user" className="form-control" required value={this.state.user.user} onChange={this.OnchangeLogin} onKeyUp={this.OnkeyUpLogin} />
                        </div>
                        <div className="form-group mt-4">
                          <label className="form-control-placeholder" htmlFor="password">PassWord</label>
                          <input id="password" type="password" name="pass" className="form-control" required value={this.state.user.pass} onChange={this.OnchangeLogin} onKeyUp={this.OnkeyUpLogin} />
                        </div>
                        <div className="form-group">
                          <button type="button" className="form-control btn btn-primary rounded submit px-3" onClick={this.Login} >Login</button>

                        </div>
                        {this.state.loading && <div className="form-group">
                          <Spin />
                        </div>}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) =>
{
  return {
    login: state.Login
  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    Login: (data) =>
    {
      dispatch(Actions.LoginRequest(data));
    },
    ResetLogin: () =>
    {
      dispatch(Actions.ResetLogin());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
